import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material/Typography';
import { type TextVariant } from '../../theme/typography';
import { type HealthxchangeThemeColours } from '@ui-kit/theme';
import { forwardRef } from 'react';

interface TextProps extends Omit<TypographyProps, 'color'> {
  variant: keyof typeof TextVariant;
  color?: Extract<keyof typeof HealthxchangeThemeColours, string>;
}

export const Text = forwardRef<HTMLElement, TextProps>((props, ref) => {
  return (
    <Typography
      ref={ref}
      {...props}
      variant={props.variant}
      color={props.color ? `${props.color}.main` : undefined}
    />
  );
});

Text.displayName = 'Text';
